// Doctor-app runtime config. MFA is enforced server-side (requireMfa; TOTP via Cognito in
// production, dev-session satisfies it locally so the flow is testable end to end). Step-up
// re-auth gates the Healthie hand-off.
export const API_ORIGIN =
  (import.meta.env.VITE_API_ORIGIN as string | undefined)?.replace(/\/+$/, "") ||
  "http://localhost:8787";

// Cognito pool config (DRS-3 terraform). Region is informational — amplify v6 derives it from the
// pool id; the API side uses it to build the issuer/JWKS URLs.
export const COGNITO_REGION =
  (import.meta.env.VITE_COGNITO_REGION as string | undefined) || "us-west-2";

export const COGNITO_USER_POOL_ID =
  (import.meta.env.VITE_COGNITO_USER_POOL_ID as string | undefined) || "";

// This app's SPA client (cc-doctor scope on the API side). USER_SRP_AUTH, no client secret.
export const COGNITO_CLIENT_ID =
  (import.meta.env.VITE_COGNITO_CLIENT_ID as string | undefined) || "";

export const COGNITO_ENABLED = COGNITO_USER_POOL_ID.length > 0 && COGNITO_CLIENT_ID.length > 0;

// Provider portal is bound to its own email domains. Enforced in the API (requirePortalDomain +
// cognito:groups); this copy just sets the expectation up front so a rejected off-domain login is
// self-explanatory. Mirror of AUTH_DOCTOR_DOMAINS on the API.
export const STAFF_DOMAINS = ["drstack.ai", "thunderbirdlabs.ai"];

// Idle auto-logout — clinician sessions are shorter than patient (shared-workstation privacy).
export const IDLE_TIMEOUT_MS = 30 * 60 * 1000;
